// Suivi global des requêtes API en cours → progression de chargement (0..1)
const state = { total: 0, done: 0 };
const listeners = new Set();
let resetTimer = null;

const emit = () => listeners.forEach((fn) => fn({ ...state }));

export const subscribeLoadProgress = (fn) => { listeners.add(fn); fn({ ...state }); return () => listeners.delete(fn); };

export const trackRequestStart = () => {
  if (resetTimer) { clearTimeout(resetTimer); resetTimer = null; }
  state.total += 1; emit();
};

export const trackRequestEnd = () => {
  state.done += 1; emit();
  if (state.done >= state.total) {
    resetTimer = setTimeout(() => { state.total = 0; state.done = 0; emit(); }, 400);
  }
};
